import { Component, HostListener, OnInit } from '@angular/core';
import { Router, Event as RouterEvent, NavigationEnd } from '@angular/router';
import { Spinkit } from 'ng-http-loader';
import './_content/app.less';
import { AuthenticationService } from './_services/authentication.service';
import { User } from './_models';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef } from '@angular/core';
import { IdleService } from './_services/idle.service';
import { environment } from '@environments/environment';
import { AppConfig } from 'src/assets/config/config/app-config';
@Component({ selector: 'app', templateUrl: 'app.component.html', styleUrls: ['./app.component.scss'] })
export class AppComponent implements OnInit {
    public spinkit = Spinkit;
    mobileQuery: MediaQueryList;
    isActive: boolean = false;
    #settingsVariable: boolean = false;
    private _mobileQueryListener: () => void;
    selectedIndex: number = 1;
    currentUser: User;
    configSection: boolean = false;
    searchText: string;
    openSearch: boolean = false;
    isHome: boolean = false;
    archive: boolean = this.config.getConfig("archive");
    enableWorkflow: boolean = this.config.getConfig("enableWorkflow");
    shouldDisplayUserIcon: boolean = this.config.getConfig("shouldDisplayUserIcon");
    aclGroup: any = this.config.getACLGroup();

    APP_VERSION:string= this.config.getConfig("ui-version");
    userGroups: string[];
    admin: boolean = false;


    constructor(
        changeDetectorRef: ChangeDetectorRef, media: MediaMatcher,
        public router: Router,
        private authenticationService: AuthenticationService,
        private idleService: IdleService,
        private config: AppConfig
    ) {

        this.router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationEnd) {
                if (event['url'].startsWith('/config/')) {
                    this.configSection = true;
                } else {
                    this.configSection = false;
                }
            }
        });
        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
        this.authenticationService.isAdmin.subscribe(x => {
            this.admin = x;
        });
        this.userGroups = authenticationService.userGroupsValue;
    }

    ngOnInit(): void {

        const enableIdleTimeout = this.config.getConfig('enableIdleTimeout')
        if (enableIdleTimeout) {
            this.initialIdleSettings();
        }

        this.login();

    }

    private initialIdleSettings() {
        const idleTimeoutInSeconds: number = this.config.getConfig('idleTimeInMinutes') * 60;
        this.idleService.startWatching(idleTimeoutInSeconds).subscribe((isTimeOut: boolean) => {
            if (isTimeOut && this.authenticationService.ongoingAPIRequests.length === 0) {
                alert("Session timeout. You will be redirected to the login page.");

                this.logout()
            }
        });
    }

    fullTextSearch() {
        console.log(this.searchText)
        this.router.navigateByUrl('/home', { state: { text: this.searchText } });
        this.cancel()
    }

    initiateSearch() {
        this.searchText = ""
        this.openSearch = true
    }

    cancel() {
        this.openSearch = false
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }

    logout() {
        this.authenticationService.logout();

        if (this.aclGroup.group === 'CA') {

            this.router.navigate(['/ssologin']);
        } else {
            this.router.navigate(['/login']);            
        }
    }

    getUserInitials() {
        return (this.currentUser) ? (this.currentUser.username.slice(0, 1)).toLocaleUpperCase() : "";
    }


    login() {        
        let userObj = null;
        userObj = localStorage.getItem('currentUser');
        if (userObj == null) {
            const location: string = window.location.href;
            let token = undefined;
            if (location.includes('?code=')) {
                token = location.substring(location.indexOf('?code=') + 6);
            }        
            if (token) {
                this.router.navigate(
                    ['/ssologin'],
                    { queryParams: { code: token } }
                  );
            } else {
                this.router.navigate(['/ssologin']);
            }
        } else {
            var lastPageVisit = localStorage.getItem('lastPageVisit');
            if (lastPageVisit) {
                localStorage.removeItem('lastPageVisit');
                this.router.navigate(['/' + lastPageVisit]);
            } else {
                this.router.navigate(['/categories']);
            }
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification(event: Event): void {
        var location = event.target['location'].href;
        if (location && !location.includes('/login') && !location.includes('/ssologin') && !location.includes('/config/home')) {
            let segments = location.split('/');
            let lastPageVisit = segments.pop();
            localStorage.setItem("lastPageVisit", lastPageVisit);
        } else if (location && location.includes('/config/home')) {
            localStorage.setItem("lastPageVisit", 'config/home');   
        } else {
            localStorage.removeItem("lastPageVisit");
        }
    }

}